import { ReactSVG } from 'react-svg';

import styled from 'styled-components';

import Loader from 'components/Loader';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  height: 100%;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }
`;

export const Body = styled.div`
  flex: 1;
  padding: 29px 0 100px 0;
`;

export const Loading = styled(Loader)`
  height: 100%;
`;

export const Title = styled.h5`
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.expensesList.primary};
`;

export const SubTitle = styled.span`
  font-size: 12px;
  text-align: center;
  color: ${({ theme }) => theme.expensesList.secondary};
`;

export const Total: any = styled.div`
  text-align: center;
  padding: 0 16px;
  margin-bottom: 16px;
`;

Total.Title = styled.h5`
  color: ${({ theme }) => theme.expensesList.primary};
`;

Total.Value = styled.h3`
  font-weight: 600;
  color: ${({ theme }) => theme.expensesList.total};
`;

export const Report: any = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  padding: 0 16px;

  & > div {
    fill: ${({ theme }) => theme.expensesList.report} !important;
  }
`;

Report.Text = styled.span`
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.expensesList.report};
`;

Report.ShareIcon = styled(ReactSVG)`
  cursor: pointer;
  padding: 5px 0 0 5px;

  & > div > svg > g {
    stroke: ${({ theme }) => theme.expensesList.report};
  }
`;

Report.DownloadIcon = styled(ReactSVG)`
  cursor: pointer;
  padding: 5px 0 0 5px;

  & > div > svg > g > g {
    stroke: ${({ theme }) => theme.expensesList.report};
  }
`;
